import { RecordType } from '@xbcb/shared-types';
import { WorkOrderBadge } from '@xbcb/work-order-types/dist/enums/workOrder/badge';

export const euClassificationBadges: Array<{ badge: WorkOrderBadge }> = [
  { badge: WorkOrderBadge.BIXD },
  { badge: WorkOrderBadge.CBAM },
  { badge: WorkOrderBadge.MULTIVAT },
  { badge: WorkOrderBadge.DG },
];

export const usClassificationBadges: Array<{ badge: WorkOrderBadge }> = [
  { badge: WorkOrderBadge.DG },
];

export const US_BADGE_SUPPORTED_RECORD_TYPES: RecordType[] = [
  RecordType.US_CONSUMPTION_ENTRY,
];

export const BADGE_SUPPORTED_RECORD_TYPES: RecordType[] = [
  RecordType.FR_CUSTOMS_ENTRY,
  RecordType.DE_CUSTOMS_ENTRY,
  RecordType.GB_CUSTOMS_ENTRY,
  RecordType.NL_CUSTOMS_ENTRY,
  RecordType.CUSTOMS_DECLARATION,
  RecordType.US_CONSUMPTION_ENTRY,
];
